module.exports = __webpack_public_path__ + "img/sertifika-8.8d5cd582.jpg";